import axios from 'axios'

const AppointmentEmailOtpService = {
  async send (email) {
    return axios.post('admin/appointment-email-otp/send', { email })
  },

  async verify (email, otp) {
    return axios.post('admin/appointment-email-otp/verify', { email, otp })
  }
}

export default AppointmentEmailOtpService
